import React, { useState, useEffect } from "react";

function LoginPage({ onLoginSuccess }) {
  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [btnHover, setBtnHover] = useState(false);

  // Check localStorage on component mount
  useEffect(() => {
    const storedUser = localStorage.getItem("smartifyUser");
    if (storedUser) {
      onLoginSuccess(JSON.parse(storedUser));
    }
  }, [onLoginSuccess]);

  const handleLogin = () => {
    if (!mobileNumber || !password) {
      alert("Please enter both mobile number and password");
      return;
    }

    setLoading(true);

    fetch("http://smartifyindia.co.in:8080/api/GetUserDetailsbyMobileNumberAndPassword", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ MobileNumber: mobileNumber, Password: password }),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data && data.length > 0) {
          const user = data[0];
          if (user.AllowMqtt === 1) {
            // Save user to localStorage for future logins
            localStorage.setItem("smartifyUser", JSON.stringify(user));
            onLoginSuccess(user);
          } else {
            alert("Access Denied. You do not have permission to access this app.");
          }
        } else {
          alert("Invalid mobile number or password");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        alert("Something went wrong. Please try again later.");
      });
  };

  return (
    <div className="min-h-screen flex justify-center items-center bg-gradient-to-br from-[#667eea] to-[#764ba2] font-sans">
      <div className="bg-white/95 p-10 rounded-xl shadow-lg text-center w-[350px]">
        <h1 className="mb-8 text-[#333] text-2xl font-bold">Smartify Login</h1>
        <input
          type="text"
          placeholder="Mobile Number"
          value={mobileNumber}
          onChange={(e) => setMobileNumber(e.target.value)}
          className="p-3 mb-4 w-full rounded-md border border-[#ccc] text-base box-border"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="p-3 mb-5 w-full rounded-md border border-[#ccc] text-base box-border"
        />
        <button
          onClick={handleLogin}
          disabled={loading}
          onMouseOver={() => setBtnHover(true)}
          onMouseOut={() => setBtnHover(false)}
          className={`w-full p-3 bg-[#667eea] text-white border-none rounded-md text-base cursor-pointer transition-all ${btnHover ? 'bg-[#5a67d8]' : ''}`}
        >
          {loading ? "Logging in..." : "Login"}
        </button>
      </div>
    </div>
  );
}

export default LoginPage;
